import React from "react";
import { useTranslation } from "react-i18next";
import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { formatNumber, tooltipContentStyle, tooltipCursorStyle } from "utils/dashboardUtils";

const HourlyTrafficChart = () => {
  const { t } = useTranslation();

  const HOURLY_TRAFFIC_DATA = [
    { hour: "9AM", value: 120 },
    { hour: "10AM", value: 180 },
    { hour: "11AM", value: 240 },
    { hour: "12PM", value: 300 },
    { hour: "1PM", value: 380 },
    { hour: "2PM", value: 330 },
    { hour: "3PM", value: 280 },
    { hour: "4PM", value: 230 },
    { hour: "5PM", value: 180 },
    { hour: "6PM", value: 150 },
    { hour: "7PM", value: 120 },
  ];

  return (
    <div className="hourly_traffic">
      <div className="hourly_traffic__header">
        <div>
          <h3 className="fs_20">{t("Hourly Traffic Volume")}</h3>
          <p className="page_sub_title mt-2">
            {t("Tunnel utilization throughout the day")}
          </p>
        </div>
      </div>
      <div className="mt-5"></div>
      {/* Chart */}
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={HOURLY_TRAFFIC_DATA} barCategoryGap="20%" barGap={6}>
          {/* <CartesianGrid
            vertical={false}
            stroke="#E6EAF0"
            strokeDasharray="0"
          /> */}

          <Tooltip
            cursor={tooltipCursorStyle}
            formatter={(value) => [`${value}`, "Vehicles"]}
            contentStyle={tooltipContentStyle}
            labelStyle={{ fontWeight: 600 }}
          />

          <XAxis
            dataKey="hour"
            axisLine={{ stroke: "#a0acb945" }}
            tickLine={false}
            tick={{ fontSize: 12, fill: "#A0ACB9", fontWeight: 500 }}
            tickMargin={15}
          />

          <YAxis
            axisLine={false}
            tickLine={false}
            tickFormatter={(value) => `${formatNumber(value)}`}
            width={40}
            tick={{
              fill: "#000000",
              fontSize: 14,
              fontWeight: 500,
            }}
          />

          <Bar dataKey="value" fill="#53c3eb" radius={[8, 8, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default HourlyTrafficChart;
